const normalizeString = value => {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value).trim();
};

const normalizeEmail = value => normalizeString(value).toLowerCase();

const normalizePhone = value => normalizeString(value).replace(/\D+/g, '');

export const buildChangedUserEditPayload = ({
  oldFirstName,
  firstname,
  oldLastName,
  lastname,
  oldEmail,
  email,
  oldPhoneNumber,
  phone_number,
}) => {
  const payload = {};

  if (oldFirstName !== firstname && firstname !== null) {
    payload.firstname = firstname;
  }
  if (oldLastName !== lastname && lastname !== null) {
    payload.lastname = lastname;
  }
  if (oldEmail !== email && email !== null) {
    payload.email = email;
  }
  if (oldPhoneNumber !== phone_number && phone_number !== null) {
    payload.phone_number = phone_number;
  }

  return payload;
};

const getResponsePayload = response => {
  if (!response || response.status !== 200 || !response.data) {
    return null;
  }

  if (response.data.status !== 'successful' || response.data.hasPayload !== true) {
    return null;
  }

  return response.data.payload || null;
};

export const getUserEditResponsePayload = response => getResponsePayload(response);

const getPayloadValueForField = (payload, fieldName) => {
  if (!payload) {
    return undefined;
  }

  if (fieldName === 'phone_number') {
    return payload.phone_number !== undefined ? payload.phone_number : payload.phone;
  }

  return payload[fieldName];
};

const valuesMatch = (fieldName, expectedValue, actualValue) => {
  if (fieldName === 'email') {
    return normalizeEmail(expectedValue) === normalizeEmail(actualValue);
  }

  if (fieldName === 'phone_number') {
    return normalizePhone(expectedValue) === normalizePhone(actualValue);
  }

  return normalizeString(expectedValue) === normalizeString(actualValue);
};

export const validateUserEditResponse = (response, expectedChanges) => {
  const payload = getResponsePayload(response);

  if (!payload) {
    const responseMessage = response && response.data && response.data.message ? response.data.message : null;
    return responseMessage || 'The server did not return the saved user details.';
  }

  const mismatchedField = Object.keys(expectedChanges).find(fieldName => {
    return !valuesMatch(fieldName, expectedChanges[fieldName], getPayloadValueForField(payload, fieldName));
  });

  if (mismatchedField) {
    return `Saved response did not include the updated ${mismatchedField.replace('_', ' ')}.`;
  }

  return null;
};